













































































import { Prop, Vue, Component } from "vue-property-decorator";
import {
  staffList,
  getSelectClassList,
  getSelectCourseList,
  autoSearchData,
  geteacherList,
  searchStudent,
} from "@/api/globalSearch";
@Component({
  name: "globalSearch",
  components: {},
})
export default class extends Vue {
  @Prop() types!: any;
  searchInfo = [
    {
      type: "searchTeacher",
      name: "教务老师:",
      list: [],
      placeholder: "请选择",
      value: "",
      lable: "name",
      dataName: "teacher_id",
    },
    {
      type: "searchStudent",
      name: "学员搜索:",
      list: [],
      placeholder: "请选择",
      value: "",
      lable: "name",
      dataName: "student_id",
    },
    {
      type: "searchClass",
      name: "班级搜索:",
      list: [],
      placeholder: "请选择",
      value: "",
      lable: "name",
      dataName: "class_id",
    },
    {
      type: "searchStaff",
      name: "员工搜索:",
      list: [],
      placeholder: "请选择",
      value: "",
      lable: "name",
      dataName: "staff_id",
    },
    {
      type: "searchCourse",
      name: "课程搜索:",
      list: [],
      placeholder: "请选择",
      value: "",
      lable: "title",
      dataName: "course_id",
    },
    {
      type: "searchBuyCourse",
      name: "购买课程:",
      list: [],
      placeholder: "请选择",
      value: "",
      lable: "title",
      dataName: "course_id",
    },
    {
      type: "selectDate",
      name: "上课时间:",
      placeholder: "请选择",
      value: "",
    },
    {
      type: "searchInput",
      name: "学员搜索:",
      placeholder: "学员名字/手机号",
      value: "",
    },
  ];
  created() {
    const _t = this;
    if (_t.types.length > 0) {
      _t.searchInfo = _t.searchInfo.filter((item: any) => {
        if (_t.types.indexOf(item.type) != -1) {
          _t.getSelectrList(_t.types[_t.types.indexOf(item.type)]);
        }
        return _t.types.indexOf(item.type) != -1;
      });
    }
  }
  handleSearch(e: any, dataName: string) {
    const data = {
      id: e,
      dataName: dataName,
    };
    this.$emit("getData", data);
  }
  selectDateChange(e: any) {
    // console.log(e);
  }
  inputEvent(e: any) {
    // console.log(e);
  }
  // 通用搜索框
  getSelectrList(e: string) {
    const _t = this as any;
    _t.globalSearch("", e);
  }
  getglobalsearchdata(data: autoSearchData, type: String) {
    if (type == "searchStaff") {
      data.status = 1;
      return staffList(data as any);
    } else if (type == "searchTeacher") {
      data.status = 1;
      return geteacherList(data);
    } else if (type == "searchClass") {
      return getSelectClassList(data);
    } else if (type == "searchCourse") {
      return getSelectCourseList(data);
    } else if (type == "searchStudent") {
      data.status = [2];
      return searchStudent(data);
    } else if (type == "searchBuyCourse") {
      data.sales_status = 1;
      return getSelectCourseList(data);
    }
  }
  async globalSearch(queryString: string, type: string) {
    const _t = this;
    let data: autoSearchData = {
      page: 1,
      page_size: 100,
    };
    let restaurants: any = {};
    if (queryString) {
      data = {
        page: 1,
        page_size: 10,
      };
      if (type == "searchClass") {
        data.name = queryString;
      } else if (type == "searchBuyCourse" || type == "searchCourse") {
        data.title = queryString;
      } else {
        data.key_word = queryString;
      }
    }
    restaurants = await _t.getglobalsearchdata(data, type);
    const list = restaurants.data.list;
    _t.searchInfo.forEach((a: any, b: number) => {
      if (a.type == type) {
        _t.searchInfo[b].list = list;
      }
    });
  }
  // 通用搜索框结束
}
